import React, { useState } from 'react';
import { makeStyles } from '@fluentui/react-components';
import { Star24Regular } from '@fluentui/react-icons';
import { RatingQuestion as RatingQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  questionTitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    color: '#242424',
    marginBottom: '12px',
  },
  ratingArea: {
    paddingLeft: '32px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  star: {
    fontSize: '28px',
    color: '#a19f9d',
    cursor: 'pointer',
    '&:hover': {
      color: '#ffc83d',
    },
  },
  starActive: {
    color: '#ffc83d',
  },
});

interface RatingQuestionViewProps {
  question: RatingQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const RatingQuestionView: React.FC<RatingQuestionViewProps> = ({
  question,
  questionNumber,
  onClick,
}) => {
  const styles = useStyles();
  const [rating, setRating] = useState<number>(0);
  const [hoverRating, setHoverRating] = useState<number>(0);

  const handleStarClick = (e: React.MouseEvent, value: number) => {
    e.stopPropagation();
    setRating(value);
  };

  const handleStarHover = (value: number) => {
    setHoverRating(value);
  };

  const handleStarLeave = () => {
    setHoverRating(0);
  };

  const renderStars = () => {
    const stars = [];
    for (let i = 1; i <= (question.maxRating ?? 5); i++) {
      const isActive = i <= (hoverRating || rating);
      stars.push(
        <Star24Regular
          key={i}
          className={`${styles.star} ${isActive ? styles.starActive : ''}`}
          onClick={(e) => handleStarClick(e, i)}
          onMouseEnter={() => handleStarHover(i)}
          onMouseLeave={handleStarLeave}
        />
      );
    }
    return stars;
  };

  return (
    <div 
      className={styles.container}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
      data-question-view
    >
      <div className={styles.questionTitle}>
        {questionNumber}. {question.title}
        {question.required && <span style={{ color: '#d13438', marginLeft: '4px' }}>*</span>}
      </div>
      
      <div className={styles.ratingArea}>
        {renderStars()}
      </div>
    </div>
  );
};
